exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".black-reason[data-v-a1b2d2ba]{margin-top:0.05333rem;padding:0.02667rem 0.08rem;background:#fdf6ec;color:#e6a23c;font-size:0.16rem;border-radius:0.05333rem;border:0.01333rem solid #f5dab1;line-height:1.4;word-break:break-all}", ""]);

// exports
